(function ($, window) {

    // On document ready
    $(function () {

        // Scroll effects
        {

            let iconBullets = $('.icon-bullets-c .icon-bullet, .ingredients .list, .ingredients .ingredient, .hero-text');
            let iconBulletsExist = !!iconBullets.length;
            let bulletVis = [];
            let scrollElement;

            if (iconBulletsExist) {
                if ($('body').hasClass('para-drop')) {
                    scrollElement = $('#wrapper')[0];
                } else {
                    scrollElement = window;
                }

                scrollElement.addEventListener('scroll', throttle(onScroll, 100), false);
                scrollElement.addEventListener('scroll', debounce(onScroll, 100), false);
                scrollElement.addEventListener('resize', debounce(onScroll, 100), false);

                iconBullets.each((i, el) => {
                    bulletVis.push(false);
                    $(el).addClass('preveal');
                });
            }

            function pastBottomEdge(el) {
                const viewportHeight = (scrollElement.innerHeight || document.documentElement.clientHeight);
                const bulletBounds = el.getBoundingClientRect();
                return bulletBounds.bottom - viewportHeight < 0;
            }

            function onScroll() {
                iconBullets.each((i, el) => {
                    const bulletsVisible = bulletVis[i];
                    const newBulletsVisible = pastBottomEdge(el);

                    if (!bulletsVisible && bulletsVisible != newBulletsVisible) {
                        bulletVis[i] = newBulletsVisible;
                        $(el).toggleClass('preveal', bulletsVisible);
                    }

                });
            }

            $(window).load(onScroll);
        }
    });

})(jQuery, window);
